<template>
  <div class="join-page">
    <TheAppBar :step="step"/>
    <v-content class="join-page__content" transition="out-in">
      <v-container>
        <v-fade-transition mode="out-in">

          <StepOne
            v-if="step === 'step-1'"
            :processing="isSubmitProcessing"
            @submit="submitStepOne"
          />

          <StepTwo
            v-if="step === 'step-2'"
            :processing="isSubmitProcessing"
            @submit="submitStep"
          />

          <StepThree
            v-if="step === 'step-3'"
            @submit="submitStep"
          />

          <StepFour
            v-if="step === 'step-4'"
          />
        </v-fade-transition>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import TheAppBar from '@/components/TheAppBar.vue';
import StepOne from '@/components/Developer/Join/StepOne.vue';
import StepTwo from '@/components/Developer/Join/StepTwo.vue';
import StepThree from '@/components/Developer/Join/StepThree.vue';
import StepFour from '@/components/Developer/Join/StepFour.vue';

export default {

  components: {
    TheAppBar,
    StepOne,
    StepTwo,
    StepThree,
    StepFour,
  },

  data() {
    return {
      isProccessing: true,
      isErrorVisible: false,
      isSubmitProcessing: false,
    };
  },

  props: {
    step: {
      type: String,
    },
  },

  computed: {
    savedStep() {
      return localStorage.getItem('Bench-Register-Step');
    },
  },

  created() {
    if (this.step !== 'step-1' && this.step !== this.savedStep) {
      this.checkCurrentStep();
    }
  },

  methods: {
    ...mapActions('auth', [
      'registerDeveloper',
    ]),

    submitStepOne(developerData) {
      this.isSubmitProcessing = true;

      this.registerDeveloper(developerData)
        .then(() => {
          localStorage.setItem('Bench-Register-Step', 'step-2');
          this.$router.push({ path: '/developer/join/step-2' });
        })
        .finally(() => {
          this.isSubmitProcessing = false;
        });
    },

    submitStep(step) {
      localStorage.setItem('Bench-Register-Step', `step-${step}`);
      this.$router.push({ path: `/developer/join/step-${step}` });
    },

    checkCurrentStep() {
      if (this.savedStep) {
        this.$router.push({ path: `/developer/join/${this.savedStep}` });
      } else {
        this.$router.push({ path: '/developer/join/step-1' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.join-page {
  margin-top: 0px;
  background: $color--bg;

  &__content {
    min-height: calc(100vh - 64px);
  }

  &__error {
    text-align: center;
    color: $color--primary;
  }
}
</style>
